export default __webpack_public_path__ + "static/opendialogue-8857058191d1a1c39ad194aec29198fd.jpg";